import { render } from "./MyPageInfoChange.vue?vue&type=template&id=527cf8fa&scoped=true"
import script from "./MyPageInfoChange.vue?vue&type=script&lang=js"
export * from "./MyPageInfoChange.vue?vue&type=script&lang=js"

import "./MyPageInfoChange.vue?vue&type=style&index=0&id=527cf8fa&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527cf8fa"]])

export default __exports__